<ngx-spinner [name]="'mapa-rotas'" type="ball-clip-rotate-pulse" [fullScreen]="false" bdColor="rgba(0, 0, 0, 0.2)">
</ngx-spinner>
<mat-card>
  <mat-card-header>
    <mat-card-title>Mapa de rotas</mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>

  <mat-card-content>

    <div class="row">
      <div class="col-auto">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>UF</mat-label>
          <mat-select [(ngModel)]="sBuscaUF" (ngModelChange)="carregarCidades(false)">
            <mat-option *ngFor="let tipo of aUFs" [value]="tipo.value">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-2">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Cidade</mat-label>
          <mat-select [(ngModel)]="sBuscaIDCidade">
            <mat-option *ngFor="let tipo of aCidades" [value]="tipo.key">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-2">
        <button class="mt-4" mat-flat-button color="primary" (click)="reload()">
          <mat-icon>search</mat-icon> Buscar
        </button>
      </div>
    </div>


    <div class="row" *ngIf="indexArrayDataAtual !== -1" @fadeAnimation>
      <div class="col-sm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>{{areaSelecionada}}</mat-label>
          <mat-chip-list #chipList (click)="picker.open()">
            <mat-chip *ngFor="let value of arrayDatas[indexArrayDataAtual]" [selectable]="false" [removable]="true"
              (removed)="remove(value)" datetime="yyyy-MM-dd HH:mm:ss">
              {{ value | date }}
              <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
            </mat-chip>
            <input [value]="resetModel" matInput [matDatepicker]="picker" [placeholder]="areaSelecionada"
              (dateChange)="dateChanged($event)" [matChipInputFor]="chipList" hidden />
          </mat-chip-list>
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker [startAt]="init" [dateClass]="dateClass"></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row mt-4" *ngIf="bConsulta">
      <div class="col-sm">
        <mat-divider></mat-divider>

        <div class="row mt-2">
          <div class="col-sm">
            <div style="color: gray; font-size: small;">* Se uma área ficar sobreposta a outra, valerá como rota para o
              usuário a área adicionada primeiramente;</div>
          </div>
        </div>

        <div class="row">
          <div class="col-auto">
            <button class="mt-2" mat-stroked-button color="{{classButton}}" (click)="deleteSelectedShape(true)">
              <mat-icon>delete_outline</mat-icon> Excluir área selecionada
            </button>
          </div>

          <div class="col-auto">
            <button class="mt-2" mat-stroked-button color="primary" (click)="alterarMarkers()">
              <mat-icon>remove_red_eye</mat-icon> {{sMarkers}}
            </button>
          </div>

          <div class="col-sm text-right">
            <button class="mt-2" mat-flat-button color="primary" (click)="salvar()">
              <mat-icon>check</mat-icon> Salvar
            </button>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-sm">
            <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" (mapReady)="onMapReady($event)">
              <!-- <agm-marker [latitude]="lat" [longitude]="lng" ></agm-marker> -->
            </agm-map>
          </div>

        </div>
      </div>
    </div>


  </mat-card-content>
</mat-card>